import { EXPERIENCE } from "../constants/Experience";
import ExperienceCard from "../components/ExperienceCard";
import ExperienceHackathonCard from "../components/ExperienceHackathonCard";
import Footer from "./Footer";

const Experience = () => {
    return (
        <>
            <section className="px-4 py-16 transition-colors duration-300 sm:px-6 sm:py-20 lg:px-8 lg:py-28 bg-gradient-to-b from-slate-50 to-white dark:from-slate-950 dark:to-slate-900">
                <div className="mx-auto max-w-6xl">
                    <header className="mb-10 max-w-3xl sm:mb-14">
                        <div className="mb-3 flex items-center gap-3 text-sm font-bold uppercase tracking-wide text-blue-600 dark:text-blue-400">
                            <span>Building, learning, leading</span>
                            <span className="text-slate-400 dark:text-slate-500"></span>
                        </div>
                        <h1 className="mb-5 text-4xl font-bold text-slate-900 dark:text-white sm:text-5xl md:text-6xl">
                            Experience
                        </h1>
                        <p className="text-lg leading-relaxed text-slate-600 dark:text-slate-300 sm:text-xl">
                            A career shaped by thoughtful engineering, steady growth, and shipping work that matters.
                        </p>
                    </header>

                    <div className="space-y-5 md:space-y-6">
                    {EXPERIENCE.map((item, index) => {
                        if (item.type === "hackathon") {
                            return (
                                    <ExperienceHackathonCard key={index} experience={item.data} index={index + 1} />
                            )
                        }

                        return (
                                    <ExperienceCard key={index} experience={item.data} index={index + 1} />
                        )
                    })}
                    </div>
                </div>
            </section>
            <Footer />
        </>
    );
};

export default Experience;